import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the classesDetail state domain
 */

const selectClassesDetailDomain = state => state.classesDetail || initialState;

/**
 * Other specific selectors
 */


const makeSelectLoading = () =>
  createSelector(
    selectClassesDetailDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectClassesDetailDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectClassesDetailDomain,
    substate => substate.id,
  );
  
const makeSelectFirstRender = () =>
  createSelector(
    selectClassesDetailDomain,
    substate => substate.firstRender,
  );

const makeSelectItemData = () =>
  createSelector(
    selectClassesDetailDomain,
    substate => substate.itemData,
    );
  
/**
 * Default selector used by ClassesDetail
 */

const makeSelectClassesDetail = () =>
  createSelector(
    selectClassesDetailDomain,
    substate => substate,
  );

export default makeSelectClassesDetail;
export {
  selectClassesDetailDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemData
};
